import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/authContext";

const ProtectedRoute = () => {
  const { auth } = useContext(AuthContext);

  // Debug logging
  if (process.env.NODE_ENV === "development") {
    console.log("ProtectedRoute auth state:", {
      isAuthenticated: auth.isAuthenticated,
      hasToken: !!auth.token,
      userRole: auth.userRole,
    });
  }

  // Check if we have complete auth state
  if (auth.isAuthenticated && auth.token && auth.userRole) {
    if (process.env.NODE_ENV === "development") {
      console.log("ProtectedRoute: Access granted");
    }
    return <Outlet />;
  } else if (!auth.isAuthenticated) {
    // If we have a token in localStorage but context hasn't updated yet,
    // show a verification view instead of redirecting immediately.
    const hasToken = Boolean(localStorage.getItem("token"));
    if (hasToken) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-white dark:bg-brand-darker">
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-brand-gold mb-4"></div>
            <p className="text-gray-700 dark:text-brand-cream text-lg">Verifying authentication...</p>
          </div>
        </div>
      );
    }
    if (process.env.NODE_ENV === "development") {
      console.log("ProtectedRoute: Access denied, redirecting to login");
    }
    return <Navigate to="/login" replace />;
  } else {
    // Still loading auth state
    return (
      <div className="flex items-center justify-center min-h-screen bg-white dark:bg-brand-darker">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-brand-gold mb-4"></div>
          <p className="text-gray-700 dark:text-brand-cream text-lg">Verifying authentication...</p>
        </div>
      </div>
    );
  }
};

export default ProtectedRoute;
